import { Reducer } from 'redux'

import { Logger } from '../../Utils/Logger'
import { TypedStorage } from '../../Utils/TypedStorage'
import { isNullOrUndefined } from '../../Utils/Various'
import { initialUserInfo, IUserInfo } from '../User/Types'

import {
  ISearchActionTypes,
  ISearchState,
  CSearchInitialState,
  ISearchParams,
  EMediaTypes,
  BucketMedia,
  IMediaSupport,
  ITimeFilters,
} from './Types';

const savedSearchedParamsState: ISearchParams | null = TypedStorage.get(
  'savedSearchedParamsState',
  null
)

let initialState = { ...CSearchInitialState }

if (initialState.params.country === null) {
  let userInfo: IUserInfo = TypedStorage.get('userInfo', initialUserInfo)
  let country: any = userInfo.country
  if (country && country.length > 0 && !isNullOrUndefined(country[0])) {
    initialState = {
      ...CSearchInitialState,
      params: {
        ...CSearchInitialState.params,
        country: country[0].toLowerCase(),
      },
    }
  }
}

if (savedSearchedParamsState !== null) {
  let newSavedSearchedParamsState = { ...savedSearchedParamsState }
  Logger.info('Reusing previous search state')

  if (savedSearchedParamsState.media) {
    console.log('in here');
    newSavedSearchedParamsState.media = EMediaTypes.TV;
    if (
      savedSearchedParamsState.bucket_id &&
      savedSearchedParamsState.bucket_id.length === 0
    ) {
      newSavedSearchedParamsState.bucket_id = BucketMedia.FR_TV;
    }
  }
  initialState = {
    ...CSearchInitialState,
    params: { ...newSavedSearchedParamsState },
  }
}

const reducer: Reducer<ISearchState> = (state = initialState, action) => {
  switch (action.type) {
    case ISearchActionTypes.SEARCH_REINIT_PARAMS: {
      return { ...CSearchInitialState };
    }
    case ISearchActionTypes.LAUNCH_SEARCH: {
      let newState = {
        ...state,
        searchResults: null,
        searchError: '',
        isLoading: true,
        params: action.payload,
      };
      TypedStorage.set('savedSearchedParamsState', newState.params);
      return newState;
    }
    case ISearchActionTypes.PAGINATE_SEARCH_SUCCESS:
    case ISearchActionTypes.LAUNCH_SEARCH_SUCCESS: {
      let newState = {
        ...state,
        searchResults: action.payload,
        oldSearchResults: action.payload,
        isLoading: false,
        searchError: '',
      };

      TypedStorage.set('savedSearchedParamsState', newState.params);
      return newState;
    }
    case ISearchActionTypes.PAGINATE_SEARCH_ERROR:
    case ISearchActionTypes.LAUNCH_SEARCH_ERROR: {
      let newState = {
        ...state,
        isLoading: false,
        searchResults: null,
        searchError: action.payload,
      };

      TypedStorage.set('savedSearchedParamsState', newState.params);
      return newState;
    }
    case ISearchActionTypes.PAGINATE_SEARCH: {
      if (action.payload && action.payload.length === 2) {
        let page = action.payload[0];
        let limit = action.payload[1];
        let params = state.params;
        params.params.page = page;
        params.params.page_size = limit;
        let newState = {
          ...state,
          isLoading: true,
          params: { ...params },
        };

        TypedStorage.set('savedSearchedParamsState', newState.params);
        return newState;
      }

      return state;
    }
    default: {
      return state;
    }
  }
}

export { reducer as SearchReducer }
